import React from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import DetailsSection from "../Components/DetailsSection";
import Variants from "../Components/Variants";
import  './Productdetails.css';
import Breadcrumb from '../Components/Breadcrumb';
import CartService from '../Services/cart.service';
import AuthService from '../Services/auth.service';
import Loader from "../Components/Loader";
import toast, { Toaster } from 'react-hot-toast';
import ProductimgSlider from "../Components/ProductimgSlide";


class Productdetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            menu : [],title : [],Help : [],ar :[],loading:false,variant:[],thumnail:'',thumnailActive:false,
            btnTxt:'+ Add', stockStatus:false, showQty: undefined,
            disabled:'',  selectedQty: 1,selectedRate:[],loading:true
            

        }
    }; 
    
    componentDidMount(){
        //const id = this.props.match.params.slug1;
        //let params = useParams();
        //const id= params.slug1
       
        const  {id2}  = this.props.params ;
        this.setState({title:id2})
        //alert(id)
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
                axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_item?item_code='+id2 + '&pin=' + localStorage.getItem('pin')), {
                    headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
                })
                .then(response=>{
                    
                    this.setState({menu:response.data['message'][0]})
                    this.setState({variant:response.data['message'][0]['variants']})
                    this.setState({selectedItem: response.data['message'][0]['item_code']})
                    this.setState({selectedRate: response.data['message'][0]['price']})
                    //alert(response.data['message'][0]['price'])
                    if(response.data['message'][0]['stock'] > 0){
                        //alert("ys")
                        this.setState({stockStatus:true})
                    }else{
                        this.setState({btnTxt:'Out of Stock'})
                    }
                // alert("okkk")
                
                this.checkItem(response.data['message'][0]['item_code'])
                this.setState({loading:false})
                //console.log(response.data['message'][0])
                })
                .catch(response=>{
                
                        alert(response)
          
                })
        }
        else{
            axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_item?item_code='+id2 + '&pin=' + localStorage.getItem('pin')), {
                headers : {'content-type': 'application/json'}
            })
            .then(response=>{
                
                this.setState({menu:response.data['message'][0]})
                this.setState({variant:response.data['message'][0]['variants']})
                this.setState({selectedItem: response.data['message'][0]['item_code']})
                this.setState({selectedRate: response.data['message'][0]['price']})
                //alert(response.data['message'][0]['price'])
                if(response.data['message'][0]['stock'] > 0){
                    //alert("ys")
                    this.setState({stockStatus:true})
                }else{
                    this.setState({btnTxt:'Out of Stock'})
                }
            // alert("okkk")
            
            this.checkItem(response.data['message'][0]['item_code'])
            this.setState({loading:false})
        // console.log(response.data['message'][0])
            })
            .catch(response=>{
            
                    alert(response)
      
            })
        }
    
    }
   
    addQty = async e => {
        //alert("ok")
        e.preventDefault();
        if(this.state.selectedQty >= this.state.menu.stock){
            // alert("stock")
            toast.error("Out of stock")
         }
         else{
        let qty = this.state.selectedQty
        this.setState({ selectedQty: 'loading...' })
        await CartService.addQty(this.state.selectedItem, qty)
            .then(response=>{
                this.setState({ selectedQty: qty + 1 })
               // alert(qty)
            })
            .catch(response=>{
               console.log("error")
            })
         }
    }
    subQty= async e => {
        e.preventDefault();
        
        if(this.state.selectedQty > 0){
            let qty = this.state.selectedQty
            this.setState({ selectedQty: 'loading...' })
              await CartService.subQty(this.state.selectedItem, this.state.selectedQty)
              .then(response=>{
                    this.setState({ selectedQty: qty + 1 })
                    this.setState({ selectedQty: (qty > 0 )?qty - 1 : qty })
                })
              
        }
       if(this.state.selectedQty <= 0){
       // this.setState({btnTxt:'Add to cart'})
        this.setState({showQty:false})
        this.setState({selectedQty:1})
        this.getData()
        CartService.update_cart_local()
        CartService.update_cart()
      } 
    }
    selectItem  = async e => {

        this.ItemCode = e.target.value
        this.setState({ selectedItem: e.target.value })
        this.setState({ selectedDesc: e.target[e.target.selectedIndex].getAttribute('data-desc') })
        this.setState({ selectedRate: e.target[e.target.selectedIndex].getAttribute('data-rate') })
        this.checkItem(this.ItemCode)
    
    }
    
    async checkItem(item_code){
        //alert("check")
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
          let cart = AuthService.getserverCartitems();
         //console.log(cart)
            try{
                if(cart.length > 0){
                    this.setState({showQty:false})
                    for (let itm in cart) {
                           // console.log(cart[itm]['qty'])
                            if(cart[itm]['item_code']===item_code){
                                  this.setState({showQty:true})
                                  this.setState({selectedItem:cart[itm]['item_code']})
                                  this.setState({selectedQty:cart[itm]['qty']})
                                // this.setState({disabled:"disabled"})
                            }
                            
                      
                    } 
                }
            }
            catch(e){  }
          
        }
        else{
            let cart = AuthService.getCartitems()
            try{
                if(cart.length > 0){
                   // alert(cart.length)
                   // console.log(cart)
                    this.setState({showQty:false})
                    for (let itm in cart) {
                            //console.log(cart[itm]['item_code'] + " - " + item_code)
                            if(cart[itm]['item_code']===item_code){
                                  this.setState({showQty:true})
                                  this.setState({selectedItem:cart[itm]['item_code']})
                                  this.setState({selectedQty:cart[itm]['qty']})
                                // this.setState({disabled:"disabled"})
                            }
                            
                      
                    } 
                }
                
            }
            catch(e){  }
        }
        
  
      }
    addToCart= async e => {
        e.preventDefault();       

       //alert(this.state.selectedRate)
       
            if(this.state.stockStatus){
                const delay = ms => new Promise(res => setTimeout(res, ms));
                try {
                
                            this.setState({showQty:"yes"})
                            let itemData={
                                item_code:this.state.selectedItem, 
                                item_name:this.state.selectedDesc?this.state.menu.item_name + ' - ' + this.state.selectedDesc : this.state.menu.item_name,
                                image:this.state.menu.website_image	,
                                desc:'', 
                                qty: this.state.selectedQty, 
                                rate:this.state.selectedRate
                            }
                            await CartService.addToCart(itemData)
                            //await CartService.update_cart_local() 
                            //alert("vvv")
                            
                        await delay(1000);
                    
                }
                catch(err) {
                    console.log(err)
                    //  document.getElementById("options-selected").insertAdjacentHTML("beforeend","<div id='sdrop' ><strong>Drop</strong> : " + e.target.value + "</div>");                                 
                }
            
        }
    }


    thumnailImgClick = async (img) => {

        //alert(img)
        this.setState({thumnailActive:true})
        this.setState({thumnail:img})
        
      }

  render() {
    const menu = this.state.menu
   const rawHTML=this.state.menu.description
    console.log(this.state.showQty)
    return this.state.loading ? <Loader/>: <div>
         <Breadcrumb head={this.state.menu.item_group} group={this.state.menu.item_name} url="/shop"/>
         <Toaster
            position="top-center"
            reverseOrder={false}
            />

        <section className="product-details-area mtb-60px ">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 " >
                            <div className="product-details-img mb-2">
                                <div className="">
                                    <div className="zoompro-border zoompro-span text-center">
                                        <img className="main-img-resize" src={this.state.thumnailActive ? process.env.REACT_APP_API_URL +this.state.thumnail : process.env.REACT_APP_API_URL + this.state.menu.website_image}  alt="" />
                                        
                                    </div>
                                    



                







                                </div>
                                <ProductimgSlider thumnailPass={this.thumnailImgClick} thumnailName={this.state.menu.name}/>
                            </div>
                        </div>

                        
                        <div className="col-xl-6 col-lg-6 col-md-12">
                         {this.state.variant.length ? this.state.variant.map((itm,j)=>{
                              return(
                                <Variants itm={itm} key={j} /> 
                              )
                            }) :
                             <DetailsSection menu={menu? menu :''} btn={this.state.btnTxt} stockStatus={this.state.stockStatus} showQty={this.state.showQty} selectedQty={this.state.selectedQty} subQty={this.subQty} addQty={this.addQty} addToCart={this.addToCart}/>}
    

                        </div>
                        <div className="col-md-12 mt-2">
                            <div className="pro-details-list">
                                <h4 className="mb-3 details-head">Description</h4>
                                    <div className="border-bottom mb-3  custom-html-style"/>
                                    <div dangerouslySetInnerHTML={{ __html:rawHTML }} />
                                        {/* <p>{this.props.menu.description}</p> */}
                                    </div>
                        </div>
                    </div>

                    {this.state.variant.length ?<div className="product-content col-12 product-des"><p className="reference">{this.state.menu.item_group}</p> <h2>{this.state.menu.item_name}</h2>{/* <span>&nbsp;Rs{this.state.menu.price}</span> */}<div className="pro-details-list custom-html-style"><p dangerouslySetInnerHTML={{ __html: rawHTML }} /></div></div> : '' }

                </div>
            </section>

    </div>
        }
    }
    export default (props) => (
        <Productdetails 
            {...props}
            params={useParams()}
    />)
    